module.exports = __webpack_public_path__ + "static/media/ronald.312d0f8d.svg";